import i18n from 'i18next';
import auth from './auth';

const headers = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${auth.getAccessToken()}`,
  'Accept-Language': i18n.language,
});

/**
 * Attempt to parse the text of the error response. If
 * none available, return a generic error.
 */
const handleError = async (response: Response) => {
  let statusText: string;
  try {
    statusText = await response.text();
  } catch (e: any) {
    statusText = 'Internal error';
  }
  throw new Error(statusText);
};

/**
 *
 * @param url full url to fetch
 */
const get = async <T>(url: string): Promise<T> => {
  const response = await fetch(url, {
    method: 'GET',
    headers: headers(),
  });
  if (response.status >= 400) {
    await handleError(response);
  }
  return response.json();
};

/**
 *
 * @param url full url to fetch
 * @param body only json body supported
 * @returns
 */
const post = async <T>(url: string, body: any): Promise<T> => {
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: headers(),
  });
  if (response.status >= 400) {
    await handleError(response);
  }
  return response.json();
};

export default { get, post };
